// sessionStorage key the form writes and the success view reads — shared contract.
export const BOOK_REQUEST_SUBMISSION_KEY = 'bookRequestSubmission'

// Article id for the dedicated book-request view; set per-env via dotenv. Empty
// disables the route. Used by the router (route path/guard) and the form (article_id attribute).
export const AMAZON_CONNECT_ARTICLE_ID =
  process.env.VUE_APP_AMAZON_CONNECT_ARTICLE_ID || ''

// Footer links for the Libro de Reclamaciones PDF, resolved by the deep-link
const FOOTER_LINKS = {
  PE: { facebook: 'https://www.facebook.com/rappi.pe', x: 'https://x.com/PeruRappi', instagram: 'https://www.instagram.com/rappi.pe' },
  CO: { facebook: 'https://www.facebook.com/RappiColombia/', x: 'https://x.com/rappicolombia', instagram: 'https://www.instagram.com/rappicolombia' },
  MX: { facebook: 'https://www.facebook.com/rappimexico/', x: 'https://x.com/rappimexico', instagram: 'https://www.instagram.com/rappimx/' },
  BR: { facebook: 'https://www.facebook.com/RappiBrasil/', x: 'https://x.com/rappibrasil', instagram: 'https://www.instagram.com/rappibrasil' },
  AR: { facebook: 'https://www.facebook.com/RappiArgentina/', x: 'https://x.com/rappiargentina', instagram: 'https://www.instagram.com/rappiargentina/' },
  CL: { facebook: 'https://www.facebook.com/Rappichile/', x: 'https://x.com/rappichile', instagram: 'https://www.instagram.com/rappichile' },
  EC: { facebook: 'https://www.facebook.com/rappi.ecuador/', x: 'https://x.com/rappi_ecuador', instagram: 'https://www.instagram.com/rappi.ecuador' },
  CR: { facebook: 'https://www.facebook.com/Rappi-CR-2474741262753845/', x: 'https://x.com/rappicostarica', instagram: 'https://www.instagram.com/rappi_costa_rica' },
  UY: { facebook: 'https://www.facebook.com/rappiuruguay/', x: 'https://x.com/rappiuruguay', instagram: 'https://www.instagram.com/rappiuruguay/' },
}

const DEFAULT_FOOTER_LINKS = FOOTER_LINKS.CO

export function footerLinks(countryCode) {
  return FOOTER_LINKS[(countryCode || '').toUpperCase()] || DEFAULT_FOOTER_LINKS
}
